/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions*/

import React, { useState, useEffect, useRef, useContext } from 'react';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext } from 'store/context';
import { useDeclineIssue } from '../../services/IssueService';
import LoaderContext from '../../contexts/LoaderContext';

import Icon from '../Icon';

import {
    Dialog,
    DialogBody,
    DialogIcon,
    DialogText,
    ContentTextarea,
    DialogCancel,
    DialogConfirm,
    TextArea
} from './styles';

const mc = new MessageCenter();
const fitinsurApi = new FitinsurAPI();

export default function ModalCancel({ idOperation, show, setDialog, history, embed }) {
    const [visible, setVisible] = useState(show);
    const [cancellationReason, setCancellationReason] = useState("");

    const authContext = useContext(GlobalAuthContext);
    const myRef = useRef();
    const { updateIsLoadingStatus } = useContext(LoaderContext);

    const handleClickOutside = e => {
        if (!myRef.current.contains(e.target)) {
            setDialog({ visible: false })
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    });

    useEffect(() => {
        setVisible(show);
    }, [show]);

    const {
        data: useDeclineIssueData,
        loading: useDeclineIssueLoading,
        error: useDeclineIssueError,
        status: useDeclineIssueStatus,
        request: useDeclineIssueRequest,
    } = useDeclineIssue(idOperation);

    useEffect(() => {
        if (useDeclineIssueStatus === 200) {
            history.push(`/embed/feedback`, {
                title: "Thanks for your response!",
                message: 'Thanks for the information, one of our brokers will get in touch soon.'
            })
        }
    }, [useDeclineIssueStatus]);

    useEffect(() => {
        updateIsLoadingStatus(useDeclineIssueLoading);
    }, [useDeclineIssueLoading]);

    const handleCancellation = () => {
        fitinsurApi.setAuthToken(authContext.token);
        fitinsurApi.requestCancelEndorsement(idOperation, cancellationReason)
            .then(resp => resp.json())
            .then(data => {
                if (data.ret_code !== 200) {
                    mc.error(data.ret_msg_details);
                    return;
                }
                history.push(`/policies`);
            })
            .catch((error) => {
                mc.error("Failed to cancel the endorsement\n" + error);
                console.error('fitPostReject - Error:', error);
            });
    }

    return (
        <Dialog canShow={visible} >
            <DialogBody ref={myRef}>
                <DialogIcon>
                    <Icon name='exclamation' />
                    <DialogText>REJECT ENDORSEMENT</DialogText>
                </DialogIcon>
                <ContentTextarea>
                    <p>Deal Analysis information</p>
                    <TextArea onChange={(e) => setCancellationReason(e.target.value)} />
                    <DialogCancel 
                        onClick={() => setDialog({ visible: false })}
                        type="button"
                    >
                        Cancel
                   </DialogCancel>
                    <DialogConfirm 
                        type="button"
                        onClick={() => {
                            if(embed){
                                useDeclineIssueRequest({declaredReason: cancellationReason})
                            } else {
                                handleCancellation()
                            }
                        }}
                    >
                        Confirm
                    </DialogConfirm>
                </ContentTextarea>
            </DialogBody>
        </Dialog>

    );
}